import { action } from 'satcheljs';
import { ActionSource } from 'owa-analytics-actions';

/**
 * Action to move shared folder items
 * @param rowKeys - rowkeys to move
 * @param originalTableViewId - tableView Id of the source folder
 * @param destinationFolderId - folderId of the destination folder
 * @param parentFolderId - folderId of the source folder
 * @param allowUndoAction - is undo allowed for this action
 * @param actionSource - source where action is performed
 */
const moveSharedFolderItems = action(
    'MOVE_SHARED_FOLDER_ITEMS',
    (
        rowKeys: string[],
        originalTableViewId: string,
        destinationFolderId: string,
        parentFolderId: string,
        actionSource?: ActionSource
    ) => {
        return {
            rowKeys,
            originalTableViewId,
            destinationFolderId,
            parentFolderId,
            actionSource,
        };
    }
);

export default moveSharedFolderItems;
